import {
  lastValidPositionDateFormatter,
  defaultFormatter,
  percentageFormatter,
} from 'utils/formatters';

export const REPORT_COLUMNS = [
  {
    label: 'IMEI',
    value: ({ shortImei }) => defaultFormatter(shortImei),
  },
  {
    label: 'IMEI Completo',
    value: ({ imei }) => defaultFormatter(imei),
  },
  {
    label: 'CCID',
    value: ({ iccid }) => defaultFormatter(iccid),
  },
  {
    label: 'Empresa',
    value: ({ currentCompany }) =>
      defaultFormatter(currentCompany && currentCompany.name),
  },
  {
    label: 'Operadora',
    value: ({ lastEventEquipment, lastEvent }) => {
      const ev = lastEventEquipment || lastEvent;
      return defaultFormatter(ev && ev.simCardOperator && ev.simCardOperator.name);
    },
  },
  {
    label: 'Sinal',
    value: ({ lastEventEquipment, lastEvent }) => {
      const ev = lastEventEquipment || lastEvent;
      return `${percentageFormatter(
        Number(ev && ev.gsmModelSignal / 31)
      )}`;
    },
  },
  {
    label: 'Última posição válida',
    value: ({ lastEventEquipment, lastEvent }) => {
      const ev = lastEventEquipment || lastEvent;
      return lastValidPositionDateFormatter(
        ev && ev.lastValidPositionDate,
        ev && ev.lastValidPositionHour
      );
    },
    sort: 'lastEventEquipment.lastValidPositionDate',
  },
  {
    label: 'ID Módulo LORA',
    value: ({ lastLoraModuleId }) => {
      if(lastLoraModuleId) {
        return lastLoraModuleId === "" ? "-" : lastLoraModuleId
      }
    },
    sort: 'lastLoraModuleId',
  },
];
